function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 0.238281V23.7624L4.53163 16.0003H1V8.00033H4.53163L11 0.238281ZM9 5.76238L5.46838 10.0003H3V14.0003H5.46838L9 18.2383V5.76238Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5472 5.88248L16.3323 6.50186C17.955 7.78208 18.9996 9.76944 18.9996 12.0002C18.9996 14.231 17.955 16.2183 16.3323 17.4986L15.5472 18.1179L14.3084 16.5477L15.0935 15.9284C16.2562 15.0111 16.9996 13.5927 16.9996 12.0002C16.9996 10.4077 16.2562 8.98933 15.0935 8.07205L14.3084 7.45267L15.5472 5.88248Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6351 8.90157L13.5007 9.4023C14.3948 9.91951 15 10.8887 15 12.0003C15 13.112 14.3948 14.0812 13.5007 14.5984L12.6351 15.0991L11.6337 13.3679L12.4993 12.8672C12.8008 12.6927 13 12.3692 13 12.0003C13 11.6315 12.8008 11.3079 12.4993 11.1335L11.6337 10.6328L12.6351 8.90157Z"
});

function SvgVolumeMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMedium);
export default __webpack_public_path__ + "static/media/volume-medium.fa208f75.svg";
export { ForwardRef as ReactComponent };